// Used in the annotation (three dots) menus on annotation cards

const onKeyDownDropdownItem = (event: any, toggleDropdownMenu: any) => {
	const key = event.key;

	// Only continue on arrow keys
	if (key !== "ArrowLeft" && key !== "ArrowUp" && key !== "ArrowRight" && key !== "ArrowDown" && key !== "Escape")
		return;

	event.preventDefault();
	event.stopPropagation();

	const parent = event.target.parentNode;

	if (key === "ArrowLeft") {
		if (parent.parentNode.parentNode.nodeName === "LI")
			parent.parentNode.parentNode.firstChild.focus();
		else if (parent.parentNode.parentNode.classList.contains("dropdown-submenu-wrapper"))
			parent.parentNode.parentNode.parentNode.firstChild.focus();
	} else if (key === "ArrowUp") {
		if (parent.previousSibling)
			parent.previousSibling.firstChild.focus();
	} else if (key === "ArrowRight") {
		if (event.target.nextSibling) {
			if (event.target.nextSibling.nodeName === "UL")
				event.target.nextSibling.firstChild.firstChild.focus();
			else
				event.target.nextSibling.firstChild.firstChild.firstChild.focus();
		}
	} else if (key === "ArrowDown") {
		if (parent.nextSibling)
			parent.nextSibling.firstChild.focus();
	} else if (key === "Escape")
		toggleDropdownMenu();
};

// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
const positionSubmenuTop = (event) => {
	if (event.target.parentElement.children.length < 2)
		return;

	const dropdownDiv = event.target.closest(".dropdown-submenu").children[1];
	const yPos = event.target.getBoundingClientRect().top - dropdownDiv.getBoundingClientRect().top;
	dropdownDiv.style.top = (yPos + dropdownDiv.offsetTop) + "px";
};

// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
const positionSubmenuOffScreen = (event) => {
	if (event.target.parentElement.children.length < 2)
		return;

	const dropdownDiv = event.target.parentElement.children[1];
	const dropdownBounds = dropdownDiv.getBoundingClientRect();

	if (dropdownBounds.y < 0) {
		// Ran off top edge
		dropdownDiv.style.top = (parseFloat(dropdownDiv.style.top) - dropdownBounds.y) + "px";
	} else if (dropdownBounds.bottom > document.documentElement.clientHeight) {
		// Ran off bottom edge
		const hiddenHeight = dropdownBounds.bottom - document.documentElement.clientHeight;
		dropdownDiv.style.top = (parseFloat(dropdownDiv.style.top) - hiddenHeight) + "px";
	}

	if (dropdownBounds.right > document.documentElement.clientWidth) {
		// Ran off right edge
		const hiddenWidth = dropdownBounds.right - document.documentElement.clientWidth;
		if (hiddenWidth < 50) {
			const dropdownLeft = parseFloat(window.getComputedStyle(dropdownDiv).getPropertyValue("left"));
			dropdownDiv.style.left = (dropdownLeft - hiddenWidth) + "px";
		} else
			dropdownDiv.style.left = (-dropdownBounds.width) + "px";
	}
};

// @ts-expect-error TS(7006) FIXME: Parameter 'event' implicitly has an 'any' type.
const resetSubmenuPosition = (event) => {
	if (event.target.parentElement.children.length < 2)
		return;

	const dropdownDiv = event.target.parentElement.children[1];
	dropdownDiv.style.left = "100%";
	positionSubmenuTop(event);
};

export default {
	onKeyDownDropdownItem,
	positionSubmenuTop,
	positionSubmenuOffScreen,
	resetSubmenuPosition
};
